import ImageComparisonFrame from './ImageComparisonFrame'

export default ImageComparisonFrame
